import logo from "assets/images/logo-background1.png";
import profile from "assets/images/profile-img.png";
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useEffect, useState } from "react";
import ResultSearch from "./SearchResult";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  searchCodePortal,
  getSearchResult,
  getCapcha,
  resetDownloadType,
} from "store/portal/actions";
import { useToasts } from "react-toast-notifications";
const Login = props => {
  const dispatch = useDispatch();
  const [detailModal, setDetailModal] = useState(false);
  const [valueParamUrl,setValueParamsUrl] = useState("")
  const [urlPDF, setUrlPDF] = useState("");
  const { addToast } = useToasts();
  const Portal = useSelector(state => state.Portal);
  const {
    loading,
    capcha,
    errorSearch,
    dataVerity,
    dataSearch,
    errorDownload,
    errorSearchResult,
    statusFailSearch,
  } = Portal;
  const handleValidSubmit = (event, values) => {
    dispatch(searchCodePortal(values));
  };
  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };
  const base64toBlob = data => {
    if (Object.keys(data).length > 0) {
      const base64WithoutPrefix = data.substr(
        "data:application/pdf;base64,".length
      );
      const bytes = atob(base64WithoutPrefix);
      let length = bytes.length;
      let out = new Uint8Array(length);

      while (length--) {
        out[length] = bytes.charCodeAt(length);
      }

      return new Blob([out], { type: "application/pdf" });
    }
  };
  useEffect(() => {
    if (
      dataSearch &&
      dataSearch.data &&
      Object.keys(dataSearch.data).length > 0
    ) {
      const blob = base64toBlob(dataSearch.data);
      const url = URL.createObjectURL(blob);
      setUrlPDF(url);
    }
  }, [dataSearch]);
  useEffect(() => {
    if (errorDownload) {
      addToast("Tải tệp không thành công, vui lòng thử lại", {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetDownloadType());
    }
  }, [errorDownload]);
  useEffect(() => {
    var invoice_code = new URLSearchParams(window.location.search).get(
      "invoice_code"
    );
    if (invoice_code) {
      setValueParamsUrl(invoice_code);
    }
  }, []);
  const fakeData = {
    status: true,
    token: "ASNDBHfajwhfajkwbgjhgbawASDKVA",
    model: [
      {
        id: 832,
        filename: "abc.pdf",
      },
      {
        id: 2,
        filename: "xyz.pdf",
      },
    ],
  };
  useEffect(() => {
    if (errorSearchResult) {
      addToast("Không tìm thấy tệp tin", {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetDownloadType());
    }
  }, [errorSearchResult]);
  useEffect(() => {
    if (dataVerity && dataVerity.model && dataVerity.model.length > 0) {
      toggleDetailModal();
      dispatch(
        getSearchResult({
          id: dataVerity.model[0].id,
          token: dataVerity.token,
        })
      );
    } else {
      if (errorSearch) {
        if (
          errorSearch.errors &&
          errorSearch.errors.captcha &&
          errorSearch.errors.captcha[0] == "VALIDATION.CAPTCHA_IS_INVALID"
        ) {
          addToast("Mã Captcha không hợp lệ", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(getCapcha());
        } else {
          if (statusFailSearch) {
            addToast("Không tìm thấy mã hóa đơn, vui lòng kiểm tra lại", {
              appearance: "error",
              autoDismiss: true,
            });
            dispatch(getCapcha());
          }
        }
      }
    }
  }, [dataVerity, errorSearch]);
  useEffect(() => {
    dispatch(getCapcha());
  }, []);
  const refreshCaptcha = () => {
    dispatch(getCapcha());
  };
  const handleCloseModel = () => {
    toggleDetailModal();
  };
  return (
    <React.Fragment>
      <MetaTags>
        <title>Tra cứu hóa đơn | Tổ chức giải pháp</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <ResultSearch
            dataSearch={dataSearch}
            isOpenModal={detailModal}
            toggleModal={toggleDetailModal}
            pdf={urlPDF}
            dataVerity={dataVerity}
            handleCloseModel={handleCloseModel}
          />
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Chào mừng bạn !</h5>
                        <p>4Si E-Invoice</p>
                        <img
                          src={logo}
                          alt=""
                          style={{
                            transform: "scale(1.3)",
                            marginLeft: "14px",
                          }}
                          height="34"
                        />
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div
                      className="avatar-md profile-user-wid mb-2"
                      style={{
                        marginLeft: "20px",
                      }}
                    ></div>
                  </div>
                  <div className="text-center h3">Tra cứu hóa đơn</div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                      }}
                    >
                      <div className="mb-3">
                        <AvField
                          name="invoice_code"
                          id="invoice_code"
                          label="Mã hóa đơn"
                          className="form-control"
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vui lòng nhập mã hóa đơn",
                            },
                          }}
                          value={valueParamUrl}
                          placeholder="Nhập mã hóa đơn"
                        />
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <AvField
                              name="captcha"
                              label="Captcha"
                              type="text"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Vui lòng nhập Captcha",
                                },
                              }}
                              placeholder="Nhập Capcha"
                            />
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center align-items-center">
                          <img width={150} src={capcha && capcha.image}></img>
                          <i
                            role="button"
                            className="fas fa-sync"
                            onClick={() => refreshCaptcha()}
                          ></i>
                        </div>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block d-flex justify-content-center align-items-center"
                          type="submit"
                        >
                          {loading && (
                            <div
                              className="spinner-border spinner-border-sm mx-2"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          )}
                          <span> Tra cứu</span>
                        </button>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-4 font-size-18 text-center text-danger">
                <p>
                  4Si E-Invoice © {new Date().getFullYear()} - Hotline: 19001837
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
